<template lang="pug">
  .list-business-documents
    .section-title Documentos
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    .table-view
      .table-view-header
        h3 {{business.name}}
          span.text-capitalize  / {{ [date, "DD-MM-YYYY"] | moment('MMMM YYYY') }}
          span(v-if="isFolder")  / {{ businessFolder ? businessFolder.folder.name : '' }}
        .table-view-actions
          BaseDateSelect(v-model="date" minDate="01-01-2018")
      hr.m-0
      .view-container.pb-3.mt-3
        ListFolder.mb-3(v-if="folders.length" :folders="folders" :year="year" :month="month")
        ListFile.mb-3(v-if="files.length" :files="files" @done="fetchData")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseDateSelect from '../common/BaseDateSelect'
import ListFolder from './ListFolder'
import ListFile from './ListFile'

export default {
  components: {
    BaseDateSelect,
    ListFolder,
    ListFile
  },
  data () {
    return {
      date: this.getPeriod()
    }
  },
  methods: {
    ...mapActions(['getBusiness', 'getBusinessFolder', 'listBusinessFolder', 'createBusinessFolderFile']),
    getPeriod () {
      if (this.$route.name === 'Home') {
        return this.$moment().date(1).format('DD-MM-YYYY')
      }
      const { year, month } = this.$route.params
      return this.$moment().year(year).month(month - 1).date(1).format('DD-MM-YYYY')
    },
    openFileUpload () {
      this.$refs['file-upload'].openInputFile()
    },
    fetchData () {
      const { folderId } = this.$route.params
      if (folderId) {
        this.getBusinessFolder({ businessId: this.user.businessId, folderId, year: this.year, month: this.month })
      } else {
        this.listBusinessFolder({ businessId: this.user.businessId, year: this.year, month: this.month })
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters(['business', 'businessFolder', 'businessFolders']),
    folders () {
      if(this.$route.params.folderId){
        let folders = []
        if (this.businessFolder) {
          folders = this.businessFolder.folder.subfolders.reduce((acum, folder) => {
            if (folder.isActive) {
              acum.push(folder)
            }
            return acum
          }, [])
        }
        return folders
      }
      return this.businessFolders
    },
    files () {
      if(this.$route.params.folderId){
        return this.businessFolder ? this.businessFolder.files : []
      }
      return []
    },
    year() {
      return this.$moment(this.date, 'DD-MM-YYYY').year()
    },
    month() {
      return this.$moment(this.date, 'DD-MM-YYYY').month() + 1
    },
    isFolder () {
      return this.$route.params.folderId ? true : false
    },
    breadcrumbs () {
      const breadcrumbs = [{
        text: 'Inicio',
        to: { name: 'Home' }
      }]
      if (this.businessFolder && this.isFolder) {
        const folder = this.businessFolder.folder

        if (folder.parentFolderId) {
          // Es sub-carpeta
          breadcrumbs.push({
            text: folder.parentFolder.name,
            to: { 
              name: 'ClientFolder',
              params: {
                folderId: folder.parentFolderId,
                year: this.year,
                month: this.month
              }
            }
          })
        }
        
        breadcrumbs.push({
          text: folder.name
        })
      }
      return breadcrumbs
    }
  },
  watch: {
    $route () {
      this.fetchData()
    },
    date () {
      if (this.$route.name !== 'Home') {
        this.$router.push({
          name: 'ClientFolder',
          params: { 
            folderId: this.$route.params.folderId,
            year: this.year,
            month: this.month
          }
        })
      }
      this.fetchData()
    }
  },
  created () {
    const { folderId } = this.$route.params
    this.getBusiness(this.user.businessId)
    if (folderId) {
      this.getBusinessFolder({ businessId: this.user.businessId, folderId, year: this.year, month: this.month })
    } else {
      this.listBusinessFolder({ businessId: this.user.businessId, year: this.year, month: this.month })
    }
  },
  beforeUpdate(){
    this.$emit('businessName',this.business.name)
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  margin-top: 20px;
}
</style>